<template>
  <v-container
    class="fill-height"
    v-if="currentPermission.privilegeLevel != 'admin'"
  >
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="5">
        <AccessDeniedCard />
      </v-col>
    </v-row>
  </v-container>
  <v-container v-else fluid>
    <v-row align="start" justify="center" class="mx-0">
      <!-- <v-col cols="12">
        <v-breadcrumbs :items="breadcrumbItems" large></v-breadcrumbs>
      </v-col> -->
      <v-col cols="7" md="7" sm="12">
        <v-card outlined>
          <v-card-title class="text-h5 d-flex justify-space-between">
            <div class="font-weight-medium">Manage Subscription</div>
            <div v-if="businessProfile.cancelAtPeriodEnd != true">
              <v-menu :close-on-click="true" left offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on">mdi-dots-horizontal</v-icon>
                </template>

                <v-list dense>
                  <v-list-item @click="cancelSubscriptionDialog = true">
                    <v-list-item-title>Cancel subscription</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </v-card-title>
          <v-card-text class="pt-4">
            <!-- <v-list>
                            <v-list-item>
                                <v-list-item-avatar color="primary" width="64" height="64">
                                    <v-icon color="white" large>show_chart</v-icon>
                                </v-list-item-avatar>

                                <v-list-item-content>
                                    <v-list-item-title class="text-h5">{{ businessProfile.productDescription }} Plan</v-list-item-title>
                                    <v-list-item-subtitle>
                                        <v-chip label class="success lighten-1" small>
                                            {{ businessProfile.subscriptionStatus.charAt(0).toUpperCase() + businessProfile.subscriptionStatus.slice(1) }}
                                        </v-chip>
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list> -->

            <div class="text-h6 font-weight-medium black--text mb-4">
              Your plan
            </div>

            <div class="d-flex justify-space-between align-center">
              <!--Start: Your plan information--->
              <v-list two-line subheader class="ma-0 pa-0">
                <v-list-item class="ma-0 pa-0">
                  <v-list-item-avatar color="rgba( 241, 95, 49, 0.24)">
                    <v-icon dark>people</v-icon>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-subtitle>Team Members</v-list-item-subtitle>
                    <v-list-item-title class="font-weight-medium">{{
                      businessProfile.noOfEmployees
                    }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
              <!--End: your plan information---->

              <div class="text-subtitle font-weight-medium black--text">
                <!-- ${{ businessProfile.nextInvoiceAmount / 100 }} -->

                <!-- {{ teamMemberAmount }}

                <sup><span class="text-caption">AUD</span></sup
                >/<span>{{
                  businessProfile.billingPeriod == "yearly" ? "year" : "month"
                }}</span> -->
              </div>
            </div>

            <!-- <v-list class="pt-0 mt-n2">
              <v-list-item two-line class="pa-0">
                <v-list-item-content>
                  <v-list-item-title class="font-weight-regular title">{{
                    planName
                  }}</v-list-item-title>
                  <v-list-item-subtitle
                    class="subheading font-weight-light grey--text pt-2"
                  >
                    <template
                      v-if="businessProfile.subscriptionStatus == 'trialing'"
                      label
                      small
                    >
                      <template
                        v-if="
                          dateDiffInDays(
                            new Date(),
                            businessProfile.nextInvoiceCreationDate.toDate()
                          ) == 1
                        "
                      >
                        {{
                          dateDiffInDays(
                            new Date(),
                            businessProfile.nextInvoiceCreationDate.toDate()
                          )
                        }}
                        day remaining of your
                        {{ businessProfile.trialPeriodDays || "30" }}-day free
                        trial period.
                      </template>
                      <template v-else>
                        {{
                          dateDiffInDays(
                            new Date(),
                            businessProfile.nextInvoiceCreationDate.toDate()
                          )
                        }}
                        days remaining of your
                        {{ businessProfile.trialPeriodDays || "30" }}-day free
                        trial period.
                      </template>
                    </template>
                    <v-chip v-else-if="businessProfile.subscriptionStatus == 'past_due'" label small>
                      Overdue
                    </v-chip>
                    <v-chip v-else label small>
                      {{
                        businessProfile.subscriptionStatus
                          .charAt(0)
                          .toUpperCase() +
                        businessProfile.subscriptionStatus.slice(1)
                      }}
                    </v-chip>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list> -->

            <v-hover v-slot="{ hover }">
              <div
                :class="[
                  'd-inline-block  primary--text cursor-pointer text-body-2 font-weight-medium mt-4 mb-4',
                  { 'text-decoration-underline': hover },
                ]"
                @click="updateCardholderLimitDialog = true"
              >
                Manage Team Members
              </div>
            </v-hover>

            <v-dialog
              v-model="updateCardholderLimitDialog"
              max-width="380"
              eager
              persistent
            >
              <UpdateCardholderLimitCard
                :initialize="updateCardholderLimitDialog"
                @canceled="updateCardholderLimitDialog = false"
              />
            </v-dialog>

            <v-divider />

            <!--Start: Optional inclusions--->
            <div class="text-h6 font-weight-medium black--text my-4">
              Optional Inclusions
            </div>

            <div
              class="d-flex justify-space-between mb-3"
              v-if="businessProfile.plan == 'evolve'"
            >
              <div class="text-subtitle font-weight-medium black--text">
                EventConnect
              </div>
              <div class="text-subtitle font-weight-medium black--text">
                <!-- ${{ multiConnectInclusionPrice }}<sup>AUD</sup>/{{
                  businessProfile.billingPeriod == "yearly" ? "year" : "month"
                }} -->
              </div>
            </div>

            <div v-else class="text-subtitle font-weight-medium black--text">
              You have not selected any optional inclusions
            </div>

            <!-- <v-btn text color="primary" class="mb-3" to="/manageOptions"
              >Manage Options</v-btn
            > -->

            <v-hover v-slot="{ hover }">
              <div
                :class="[
                  'd-inline-block primary--text cursor-pointer text-body-2 font-weight-medium my-3',
                  { 'text-decoration-underline': hover },
                ]"
                @click="$router.push({ name: 'manageOptions' })"
              >
                {{
                  businessProfile.plan == "evolve"
                    ? "Manage Options"
                    : "View Optional Inclusions"
                }}
              </div>
            </v-hover>

            <!-- <div class="d-flex justify-space-between">
              <div>Business Card Prize Draw</div>
              <div>$81<sup>AUD</sup>/year</div>
            </div> -->

            <!-- <v-list width="fit-content">
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="primary--text">Manage Options</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list> -->

            <!--End: Optional inclusions---->

            <!-- <v-row>
              <v-col cols="12" sm="4">
                <v-list two-line subheader class="ma-0 pa-0">
                  <v-list-item class="my-0 py-0">
                    <v-list-item-avatar color="rgba( 241, 95, 49, 0.24)">
                      <v-icon dark>people</v-icon>
                    </v-list-item-avatar>

                    <v-list-item-content>
                      <v-list-item-subtitle>Team Members</v-list-item-subtitle>
                      <v-list-item-title class="font-weight-medium">{{
                        businessProfile.noOfEmployees
                      }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-col>
              <v-col cols="12" sm="4">
                <v-list two-line subheader class="ma-0 pa-0">
                  <v-list-item class="my-0 py-0">
                    <v-list-item-avatar color="rgba( 241, 95, 49, 0.24)">
                      <v-icon dark>event</v-icon>
                    </v-list-item-avatar>

                    <v-list-item-content>
                      <v-list-item-subtitle>Next Billing Date</v-list-item-subtitle>
                      <v-list-item-title class="font-weight-medium">{{
                        formatDate(businessProfile.nextInvoiceCreationDate.toDate())
                      }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-col>
              <v-col cols="12" sm="4">
                <v-list two-line subheader class="ma-0 pa-0">
                  <v-list-item class="my-0 py-0">
                    <v-list-item-avatar color="rgba( 241, 95, 49, 0.24)">
                      <v-icon dark>mdi-currency-usd</v-icon>
                    </v-list-item-avatar>

                    <v-list-item-content>
                      <v-list-item-subtitle
                        >Cost Per
                        {{ businessProfile.billingPeriod == "yearly" ? "Year" : "Month" }}</v-list-item-subtitle
                      >
                      <v-list-item-title class="font-weight-medium"
                        >${{ businessProfile.nextInvoiceAmount / 100 }}
                        <sup><span class="text-caption">AUD</span></sup></v-list-item-title
                      >
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-col>
            </v-row> -->
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="5" md="5" sm="12">
        <v-card outlined class="mb-4">
          <v-card-title class="font-weight-medium text-h5">
            Next Charge
          </v-card-title>
          <v-card-text>
            <div class="d-flex justify-space-between">
              <div class="text-subtitle font-weight-medium black--text">
                {{
                  formatDate(businessProfile.nextInvoiceCreationDate.toDate())
                }}
              </div>
              <div class="text-subtitle font-weight-medium black--text">
                ${{ businessProfile.nextInvoiceAmount / 100
                }}<sup
                  ><span class="text-caption font-weight-medium black--text"
                    >AUD</span
                  ></sup
                >
              </div>
            </div>
          </v-card-text>
        </v-card>

        <v-card outlined
          ><v-card-title>Payment Method</v-card-title>
          <v-card-text>
            <p
              v-if="
                businessProfile.lastFour != undefined &&
                businessProfile.lastFour != ''
              "
            >
              <v-chip class="ma-1" label dark>
                {{ businessProfile.paymentMethod.toUpperCase() }}
              </v-chip>
              <v-icon>more_horiz</v-icon>
              <v-icon>more_horiz</v-icon>
              <v-icon>more_horiz</v-icon>
              <span class="text-subtitle-1">{{
                businessProfile.lastFour
              }}</span>
            </p>
            <v-alert v-else text color="amber" dense>
              <h3 class="text-h6">No Payment Method</h3>
              <div class="text-body-2">You have no saved payment methods.</div>

              <v-row align="center" no-gutters class="mt-4">
                <v-col class="grow"> </v-col>
                <v-spacer></v-spacer>
                <v-col class="shrink">
                  <v-btn
                    color="amber"
                    outlined
                    @click="updatePaymentDetailsDialog = true"
                  >
                    Add Payment Method
                  </v-btn>
                </v-col>
              </v-row>
            </v-alert>

            <!-- <v-btn
              text
              class="mb-3"
              color="primary"
          
              >Update payment details</v-btn
            > -->

            <v-hover v-slot="{ hover }">
              <div
                v-if="
                  businessProfile.lastFour != undefined &&
                  businessProfile.lastFour != ''
                "
                :class="[
                  'd-inline-block  primary--text cursor-pointer text-body-2 font-weight-medium mt-4 mb-4',
                  { 'text-decoration-underline': hover },
                ]"
                @click="updatePaymentDetailsDialog = true"
              >
                Update Payment Details
              </div>
            </v-hover>

            <br />
            <!-- <v-btn class="mb-3" text color="primary" to="/manageBilling"
              >View Billing History</v-btn
            > -->

            <v-hover v-slot="{ hover }">
              <div
                :class="[
                  'd-inline-block  primary--text cursor-pointer text-body-2 font-weight-medium mb-4',
                  { 'text-decoration-underline': hover },
                ]"
                @click="$router.push({ name: 'ManageBilling' })"
              >
                View Billing History
              </div>
            </v-hover>

            <v-dialog v-model="loadingDialog" persistent width="300">
              <v-card color="primary" dark>
                <v-card-text>
                  {{ loadingMessage }}
                  <v-progress-linear
                    indeterminate
                    color="white"
                    class="mb-0"
                  ></v-progress-linear>
                </v-card-text>
              </v-card> </v-dialog
          ></v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="cancelSubscriptionDialog" max-width="500">
      <v-card>
        <v-card-title class="headline">Cancel Subscription</v-card-title>

        <v-card-text>
          <!-- <template v-if="businessProfile.plan != 'evolve'">
            <p class="text-subtitle-1">
              Any cards you have issued to your team members will no longer be
              available inside their Pappyon app 24 hours after your current
              billing period has ended. They will be alerted to their card's
              removal and will be able to transfer any accrued connections to a
              new personal card.
            </p>
          </template>
          <template v-if="businessProfile.plan == 'evolve'">
            <v-carousel
              cycle
              hide-delimiter-background
              :show-arrows="false"
              light
              height="200"
              class="my-4"
              v-model="carouselForUpcomingEvents"
              :hide-delimiters="slideBody2 == ''"
            >
              <v-carousel-item height="100%">
                <v-sheet light height="180">
                  <div
                    class="text-body-2 font-weight-bold"
                    v-if="slideBody2 != ''"
                  >
                    Cancelling your optional inclusion
                  </div>
                  <div class="text-body-1" v-html="slideBody1"></div>
                </v-sheet>
              </v-carousel-item>
              <v-carousel-item height="100%" v-if="slideBody2 != ''">
                <v-sheet light height="200">
                  <div class="text-body-2 font-weight-bold">
                    Cancelling your plan
                  </div>

                  <div class="text-body-1" v-html="slideBody2"></div>
                </v-sheet>
              </v-carousel-item>
            </v-carousel>
          </template> -->
          <p class="text-subtitle-2">
            Cancelling your subscription would lead to your business profile
            being deactivated on
            {{
              businessProfile.nextInvoiceCreationDate
                .toDate()
                .toLocaleDateString()
            }}. Once this happens, any cards you have issued to your team
            members will no longer be available inside their Pappyon app. They
            will be alerted to their card's removal and will be given 48 hours
            to transfer any accrued connections to a new personal card.
          </p>
          <v-btn
            class="text-body-1"
            large
            elevation="0"
            color="primary"
            block
            @click="cancelSubscription"
          >
            {{ cancelSubscriptionButtonText }}
          </v-btn>

          <v-btn
            class="mt-2 text-body-1"
            large
            text
            elevation="0"
            color="primary"
            block
            @click="cancelSubscriptionDialog = false"
          >
            Not now
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="loadingDialog" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          {{ loadingMessage }}
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- <v-row no-gutters class="mt-2">
      <v-col> <router-link class="ml-4 mt-5" to="/manageBilling">Manage Billing</router-link><br /> </v-col>
    </v-row>
    <v-row no-gutters class="mt-2">
      <v-col>
        <a class="text-decoration-underline ml-4" @click="openPricingUrl()">See Plans and Pricing</a><br />
      </v-col>
    </v-row>
    <v-row no-gutters class="mt-2">
      <v-col>
        <SendRequestDialog
          requestType="CONTACT_US"
          :showDialog="sendRequestDialog"
          @canceled="sendRequestDialog = false"
        />
        <a class="text-decoration-underline ml-4" @click="sendRequestDialog = true"
          >Need custom options? Contact us about your plan</a
        ><br />
      </v-col>
    </v-row> -->
    <AddEditPaymentMethodDialog
      v-if="updatePaymentDetailsDialog"
      :show="updatePaymentDetailsDialog"
      @close="updatePaymentDetailsDialog = false"
    />
  </v-container>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

import Utility from "@/shared/utility";
import AccessDeniedCard from "@/components/AccessDeniedCard";
import UpdateCardholderLimitCard from "@/components/UpdateCardholderLimitCard";
import SendRequestDialog from "@/components/SendRequestDialog";
import * as currency from "currency.js";
import AddEditPaymentMethodDialog from "@/components/ManageSubscription/AddEditPaymentMethodDialog";
import {getHttpsCallable} from "@/shared/firebase_utils";

let stripe = Stripe(
  process.env.NODE_ENV == "production"
    ? "pk_live_51H57KKAb8fzN3Ilf9WjqI74BNpQmDCLJ5BdPu1XwMVIxjPdpJ21ZWKAIC0c0IOWkiHMcQ8XcWk9222zodr65ujKm00PucB5bqX"
    : "pk_test_51H57KKAb8fzN3IlflYhq2h05V8HKROSO5ZstUVOsHy9X3kmwfUL2x6z52yc67CYdALFdHbItBtiHwcMdKigqnhs800oWdLxtrs"
);
let elements = stripe.elements();
let cardElement = elements.create("card");

export default {
  name: "ManageSubscription",
  components: {
    AccessDeniedCard,
    UpdateCardholderLimitCard,
    SendRequestDialog,
    AddEditPaymentMethodDialog,
  },
  created() {
    this.formatDate = Utility.formatDate;
    this.getSubscriptionPlanTitle = Utility.getSubscriptionPlanTitle;
    this.dateDiffInDays = Utility.dateDiffInDays;
    this.openPricingUrl = Utility.openPricingUrl;
  },
  // mounted() {
  //   cardElement.mount(this.$refs.cardElement);
  //   cardElement.on("change", (event) => {
  //     this.showCardError(event);
  //   });
  // },
  data() {
    return {
      sendRequestDialog: false,
      updateCardholderLimitDialog: false,
      cancelSubscriptionDialog: false,
      loadingDialog: false,
      loadingMessage: "",
      cardError: "",
      breadcrumbItems: [
        {
          text: "Home",
          disabled: false,
          to: "/",
        },
        {
          text: "Subscription",
          disabled: false,
          to: "/subscription",
        },
        {
          text: "Manage Subscription",
          disabled: true,
        },
      ],
      updatePaymentDetailsDialog: false,
      carouselForUpcomingEvents: 0,
      monthlyPerCardPrice: currency(3.0),
      yearlyPerCardPrice: currency(28.8),
    };
  },
  computed: {
    ...mapGetters([
      "businessProfile",
      "currentPermission",
      "pricingUrl",
      "userProfile",
      "hasUpcomingEvents",
      "noOfActiveEvents",
      "noOfCardHolders",
      "noOfUpcomingEvents",
      "totalNoOfRegistrants",
      "upcomingEvents",
    ]),
    planName() {
      return this.getSubscriptionPlanTitle(this.businessProfile.plan);
    },
    cancelSubscriptionButtonText() {
      if (this.noOfCardHolders > 0) {
        if (
          (this.noOfActiveEvents > 0 || this.noOfUpcomingEvents > 0) &&
          this.carouselForUpcomingEvents == 0
        ) {
          return "Next";
        } else return "Cancel subscription";
      } else return "Cancel subscription";
    },

    slideBody1() {
      console.log("noOfActiveEvents: ", this.noOfActiveEvents);
      //Start: For users on a free trial
      if (this.businessProfile.subscriptionStatus == "trialing") {
        //For evolve plan
        if (this.businessProfile.plan == "evolve") {
          //Start: Check if there any events after the free trial ends
          let eventsAfterFreeTrialEnds = this.upcomingEvents.filter((event) => {
            return (
              event.startDateTime >=
              this.businessProfile.nextInvoiceCreationDate.toDate()
            );
          });

          if (eventsAfterFreeTrialEnds.length > 0) {
            //Start: Check if there are any attendees for eventsAfterFreeTrialEnds
            let noOfAttendees = 0;
            eventsAfterFreeTrialEnds.forEach((event) => {
              if (event.attendees.length > 0)
                noOfAttendees += event.attendees.length;
            });
            console.log("noOfAttendees: ", noOfAttendees);
            if (noOfAttendees > 0) {
              //Set the attendee text
              let attendeeText =
                noOfAttendees == 1
                  ? "and there is 1 attendee who has opted into your event"
                  : `and there are ${noOfAttendees} attendees who have opted into your events`;

              //Set the event text
              let eventText =
                eventsAfterFreeTrialEnds.length == 1
                  ? "an upcoming event happening after the free trial ends"
                  : `${eventsAfterFreeTrialEnds.length} upcoming events happening after the free trial ends`;

              //return the final text
              return `<p>You have ${eventText} ${attendeeText}</p><p>They won't be able to access the ${
                eventsAfterFreeTrialEnds.length == 1 ? `event` : `events`
              } if you cancel your subscription now.</p>`;
            } else {
              let eventText =
                eventsAfterFreeTrialEnds.length == 1
                  ? "an upcoming event happening after the free trial ends"
                  : `${eventsAfterFreeTrialEnds.length} upcoming events happening after the free trial ends`;

              return `<p>Cancelling your subscription will also cancel your add-ons. You have ${eventText} and invitations have been sent. Attendees will not be able to join EventConnect if you cancel your subscription now.</p>`;
            }
            //End: Check if there are any attendees for eventsAfterFreeTrialEnds
          } else {
            return `<p>Cancelling free trial will also cancel the EventConnect add-on. Any cards you have issued to your team members will no longer be available inside their Pappyon app 24 hours after your current billing period has ended. They will be alerted to their card's removal and will be able to transfer any accrued connections to a new personal card.</p>`;
          }
          //End: Check if there any events after the free trial ends
        } else {
          return `<p>Any cards you have issued to your team members will no longer be available inside their Pappyon app 24 hours after your current billing period has ended. They will be alerted to their card's removal and will be able to transfer any accrued connections to a new personal card.</p>`;
        }
      }
      //End: For users on a free trial
      else {
        console.log("noOfActiveEvents: ", this.noOfActiveEvents);
        if (this.noOfActiveEvents > 0) {
          return `You have ${this.noOfActiveEvents} ${
            this.noOfActiveEvents == 1 ? ` Active Event` : ` Active Events`
          } which will be deactivated immediately if you cancel your subscription now. Any cards you have issued to yourself and your team members will no longer be available inside their Pappyon app 24 hours after your subscription has been cancelled. They will be alerted to their card's removal and will be able to transfer any accrued connections to a new personal card.`;
        } else if (
          this.noOfUpcomingEvents > 0 &&
          this.totalNoOfRegistrants > 0
        ) {
          return `You have ${
            this.noOfUpcomingEvents == 1
              ? ` an upcoming event `
              : `${this.noOfUpcomingEvents} upcoming events `
          } and there
          ${
            this.totalNoOfRegistrants == 1
              ? ` is 1 registrant who has opted into your event. Attendees will not be able to join EventConnect if you cancel your subscription now`
              : ` are ${this.totalNoOfRegistrants} registrants who have opted into your events. Attendees will not be able to join EventConnect if you cancel your subscription now`
          }`;
        } else if (
          this.noOfUpcomingEvents > 0 &&
          this.totalNoOfRegistrants == 0
        ) {
          return `Cancelling your subscription will also cancel your add-ons. You have ${
            this.noOfUpcomingEvents == 1
              ? ` an upcoming event `
              : `${this.noOfUpcomingEvents} upcoming events`
          } for which invitations have been sent. Attendees will not be able to join EventConnect if you cancel your subscription now`;
        }
        // else if (
        //   this.noOfUpcomingEvents == 0 &&
        //   this.businessProfile.subscriptionStatus == "trialing"
        // ) {
        //   return `Cancelling your subscription will also cancel the Multi Connect add-on. You will continue to have access to all features in your business poprtal until your free trial ends on ${this.formatDate(
        //     this.businessProfile.nextInvoiceCreationDate.toDate()
        //   )}`;
        // }
        else {
          if (this.noOfCardHolders > 0) {
            let cardIssuedText =
              this.noOfCardHolders == 1
                ? "The card you have issued "
                : "All " + this.noOfCardHolders + " cards you have issued";
            return `Cancelling your subscription will also cancel EventConnect. ${cardIssuedText} will be deactivated and can no longer be used to connect with other people`;
          } else
            return `Any cards you have issued to yourself and your team members will no longer be available inside their Pappyon app 24 hours after your subscription has been cancelled. They will be alerted to their card's removal and will be able to transfer any accrued connections to a new personal card.`;
        }
      }
    },
    slideBody2() {
      if (this.noOfCardHolders > 0) {
        if (this.noOfActiveEvents > 0 || this.noOfUpcomingEvents > 0) {
          return `${
            this.noOfCardHolders == 1
              ? `The ${this.noOfCardHolders} card you have issued to your team member`
              : `All ${this.noOfCardHolders} cards you have issued to your team members`
          } will no longer be available inside their Pappyon app 24 hours after subscription has been cancelled.<p>They will be alerted to their card's removal and will be able to transfer any accrued connections to a new personal card.</p>`;
        } else return "";
      } else return "";
    },
    multiConnectInclusionPrice() {
      if (this.businessProfile.billingPeriod == "yearly") return 96;
      else return 10;
    },
    teamMemberAmount() {
      let additionalBusinessCards = this.businessProfile.noOfEmployees - 1;
      if (this.businessProfile.billingPeriod == "yearly") {
        return this.yearlyPerCardPrice
          .multiply(additionalBusinessCards)
          .add(this.yearlyBasePrice);
      } else
        return this.monthlyPerCardPrice
          .multiply(additionalBusinessCards)
          .add(this.monthlyBasePrice);
    },
    monthlyBasePrice() {
      // if (this.businessProfile.plan == "evolve") return currency(29.95);
      return currency(19.95);
    },
    yearlyBasePrice() {
      // if (this.businessProfile.plan == "evolve") return currency(287.52);
      return currency(191.52);
    },
  },
  methods: {
    ...mapActions(["updateBusinessProfileDetails", "showSnackbar"]),
    async cancelSubscription() {
      //Check if user has upcoming events
      if (
        this.businessProfile.plan == "evolve" &&
        this.carouselForUpcomingEvents == 0 &&
        this.noOfCardHolders != 0
      ) {
        this.carouselForUpcomingEvents = 1;
      } else {
        //Set carousel to first item
        this.carouselForUpcomingEvents = 0;

        this.cancelSubscriptionDialog = false;
        this.loadingMessage = "Cancelling Subscription...";
        this.loadingDialog = true;
        try {
          //Call a cloud function to cancel the subscription
          const cancelSubscription = getHttpsCallable("setSubscriptionAutoRenewal");
          const response = await cancelSubscription({
            subscriptionId: this.businessProfile.subscriptionId,
            email: this.userProfile.email,
            firstName: this.userProfile.firstName,
            cancelAtPeriodEnd: true,
          });
          console.log("cancel sub response: ", response);
          // await this.updateBusinessProfileDetails({
          //   subscriptionStatus: response.data.status,
          // });
          this.loadingDialog = false;
          // await firebase.auth().signOut();
          // this.$router.push("/login");
        } catch (error) {
          console.log(error);
          this.loadingDialog = false;
          this.showSnackbar({
            show: true,
            text: "Error occurred, please try again!",
          });
        }
      }
    },
  },
};
</script>